/* eslint-disable @typescript-eslint/prefer-readonly-parameter-types */
import { FC } from "react";
import { DataTestids } from "../../common/miscellaneous/DataTestids";

type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  /**
   * required for testing
   */
  readonly "data-testid": DataTestids;
  readonly className?: string;
  readonly content?: string;
};

export const Button: FC<Props> = (props) => {
  // eslint-disable-next-line react/forbid-elements
  return <button {...props} className={`mkhc-btn ${props.className || ""}`} />;
};
